var _g, _rect, _rect2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoProgramCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 120,
    viewBox: "0 0 169 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_733_14415)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.334,
    cy: 88.0038,
    rx: 5.83059,
    ry: 38.0157,
    transform: "rotate(67.3796 127.334 88.0038)",
    fill: "url(#paint0_linear_733_14415)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 39.9336,
    width: 57.8136,
    height: 70.3923,
    rx: 1.45139,
    transform: "rotate(-25.5486 13 39.9336)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    strokeDasharray: "8.72 8.72"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.0405,
    y: 34.373,
    width: 57.8136,
    height: 70.3923,
    rx: 1.45139,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    strokeDasharray: "8.72 8.72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78 58V81.5",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7549 69.7451L66.2549 69.7451",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_733_14415",
    x: 86.2863,
    y: 66.5353,
    width: 82.0954,
    height: 42.9372,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.94182,
    result: "effect1_foregroundBlur_733_14415"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_733_14415",
    x1: 121.51,
    y1: 49.9881,
    x2: 91.3849,
    y2: 74.3371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProgramCards);
export default __webpack_public_path__ + "static/media/no_program_cards.003c6021d3168709dd2c9606e9dd290e.svg";
export { ForwardRef as ReactComponent };